import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppEvents } from 'src/app/app.config/app-events';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Agente } from 'src/app/app.domain.models/agente';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { EmailTemplateApiService } from 'src/app/app.domain.services/email-template.api.service';
import { EnvioEmailApiService } from 'src/app/app.domain.services/envio-email.api.service';
import { PdfApiService } from 'src/app/app.domain.services/pdf.api.service';
import { PolizaApiService } from 'src/app/app.modules/individual/domain.services/poliza.api.service';
import { Utilidades } from 'src/app/app.utilidades/utilidades';
import { Archivo } from 'src/app/core.models/archivo';
import { EventBrokerService } from 'src/app/core.services/event-broker.service';
import { SesionService } from 'src/app/core.services/sesion.service';
import { UserService } from 'src/app/core.services/user.service';
import { PipeCurrencyEuroSinDecimales } from 'src/app/core.utilidades/pipeEuroSinDecimales';

@Component({
    selector: 'app-solicitud-en-curso',
    templateUrl: './solicitud-en-curso.component.html',
    styleUrls: ['./solicitud-en-curso.component.scss'],
})
export class SolicitudEnCursoComponent implements OnInit {

    readonly CONSTANTES = ConstantesApp;

    cliente!: Cliente;
    poliza!: Poliza;
    pdfCompanniaCompleto!: Archivo;
    pdfCompanniaAnonimo!: Archivo;
    agente!: Agente;

    constructor(
        private sesion: SesionService,
        private pdfService: PdfApiService,
        private userService: UserService,
        private emailTemplateService: EmailTemplateApiService,
        private envioEmailService: EnvioEmailApiService,
        private eventService: EventBrokerService,
        private pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales,
        private datePipe: DatePipe,
        private router: Router,
        private polizaApiService: PolizaApiService,
    ) {
        this.cliente = this.sesion.getCliente();
        this.poliza = this.sesion.getPoliza();
    }

    ngOnInit() {
        if (!this.sesion.getPoliza()?.id) {
            this.router.navigate([ConstantesApp.PATH_FORBIDDEN]);
        } else {
            Utilidades.generarPdfCoberturasEnviarEmail(this.poliza, this.pdfService, this.datePipe, this.emailTemplateService, this.envioEmailService, this.pipeEuroSinDecimales);
            setTimeout(() => {
                Utilidades.enviarMailSetNewPassword(this.cliente.email, this.userService, this.emailTemplateService, this.envioEmailService, this.poliza);
            }, 10000);
            setTimeout(() => {
                Utilidades.generarPdfCompania(this.poliza, this.polizaApiService, this.pdfService, this.pipeEuroSinDecimales, this.emailTemplateService, this.envioEmailService);
            }, 5000);
            this.sesion.clearSession();
            this.agente = this.poliza?.colectivo?.agente ? this.poliza.colectivo.agente : this.poliza?.tipoPoliza?.agente;
        }
    }

    public descargarPdf() {
        Utilidades.generarPdfColectivoCobertura(this.cliente, this.poliza, this.pdfService, this.datePipe).then((pdf) => {
            if (pdf) {
                this.eventService.publishEvent(AppEvents.previsualizarPDF, pdf);
            }
        });
    }
}
